<script>
    import './VSlider.css';
    import {onMount} from 'svelte';

    const TIMEOUT = 70;

    export let min = 0;
    export let max = 0;
    export let value = 0;
    export let step = 0;
    export let tooltip = false;

    let bar;
    let ratio;
    let hasTooltip = false;
    onMount(() => {        
        const a = parseFloat(min);
        const z = parseFloat(max);        
        if (!isNaN(a) && !isNaN(z)) {                            
            const {height} = bar.getBoundingClientRect();
            ratio = (z - a) / height;
        }        
        switch (typeof tooltip) {
            case 'boolean':
                hasTooltip = tooltip;
                break;
            case 'string':
                hasTooltip = tooltip.toLowerCase() === 'true';
                break;
            default:
                break;
        }
    });

    let tick;
    $: {
        if (tick && ratio) {
            const a = parseFloat(min);
            const z = parseFloat(max);                
            const v = parseFloat(value);
            if (!isNaN(a) && !isNaN(z) && !isNaN(v) && a <= v && v <= z) {                    
                tick.style.top = `${v / ratio}px`;
            } 
        }        
    }

    let slider;
    function click (e) {        
        const a = parseFloat(min);
        const z = parseFloat(max);
        const {top} = slider.getBoundingClientRect();        
        let v = (e.clientY - top) * ratio;        
        if (!isNaN(z) && !isNaN(a) && a <= v && v <= z) {
            value = v;
        }
    }
    
    let moving = false;
    let startX;
    let initial;
    let tooltipVisible = false;
    function start (e) {                    
        moving = true;        
        startX = e.clientY;
        initial = parseFloat (value);
        if (hasTooltip) {
            tooltipVisible = true;
        }         
    }
    function move(e) {
        if (moving && ratio) {
            setTimeout(() => {                                      
                document.body.style.cursor = 'pointer';                
                const a = parseFloat(min);
                const z = parseFloat(max);
                const s = parseFloat (step);                                        
                let d = (e.clientY - startX) * ratio;
                if (s > 0) {
                    d = Math.floor (d / s) * s;
                }
                const v = initial + d;
                if (!isNaN(z) && !isNaN(a) && a <= v && v <= z) {
                    value = v;
                }                 
            }, TIMEOUT);                                   
        }
    }
    function stop (e) {                      
        moving = false;
        document.body.style.cursor = 'initial';
        if (hasTooltip) {
            tooltipVisible = false;
        }                
    }    
        
</script>

<svelte:window on:mouseup|stopPropagation="{stop}" on:mousemove|stopPropagation="{move}"/>
<div class="vslider" bind:this="{slider}" on:click|stopPropagation="{click}">
    <slot></slot>
    <div class="vslider-bar" bind:this="{bar}">
        <div class="vslider-tick" bind:this="{tick}" on:mousedown|stopPropagation="{start}">
            {#if hasTooltip}
                <div class="vslider-tooltip" class:hidden="{!tooltipVisible}">{parseFloat(value).toFixed()}</div>
            {/if}
        </div>        
    </div>
</div>